var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.053,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20860",
    transform: "translate(22643.405 4979.5)",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 6530",
    fill: "none",
    stroke: "#869dad",
    d: "M-22641.656-4964h9.533"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 3506",
    cx: 5.998,
    cy: 5.955,
    rx: 5.998,
    ry: 5.955,
    transform: "translate(-22642.848 -4977.607)",
    fill: "#fff",
    stroke: "#869dad"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 6534",
    fill: "none",
    stroke: "#f24040",
    d: "M-22635.049-4971.688h-5.635"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12036",
    d: "M-22642.051-4974.485a2.157 2.157 0 1 1 3.22-2.737",
    fill: "none",
    stroke: "#869dad"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12037",
    d: "M-22634.982-4977.262a2.157 2.157 0 1 1 3.324 2.64",
    fill: "none",
    stroke: "#869dad"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 6539",
    fill: "none",
    stroke: "#869dad",
    d: "M-22638.779-4979h3.703"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12038",
    d: "m-22637.463-4974.151 2.544 2.544-2.528 2.527",
    fill: "none",
    stroke: "#f24040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLate);
export default __webpack_public_path__ + "static/media/Login_late.28f2150514712473265b9d8627202b82.svg";
export { ForwardRef as ReactComponent };